<template>
  <div>
    <div class="home" v-scroll-spy="{ offset: 130 }">
      <Hero />
      <LandingVideo />
      <Divider />
      <Allstar />
      <Divider />
      <Perks />
      <EventsGallery />
      <DividerTwo />
      <SeatingPricing @modalShow="modalShow" />
      <!-- <NextSteps /> -->
      <!-- <MeetRep /> -->
      <Faq @modalShow="modalShow" />
      <Divider />
    </div>
    <AppHeader @modalShow="modalShow"></AppHeader>
    <FormModal :modalActive="modalActive" @modalHide="modalHide" />
  </div>
</template>
<script>
import AppHeader from "@/layout/Header.vue";
import Hero from "./Hero";
import LandingVideo from "./LandingVideo";
// import NextSteps from "./NextSteps";
import Allstar from "./Allstar";
import Perks from "./Perks";
// import MeetRep from "./MeetRep";
import SeatingPricing from "./SeatingPricing";
import Faq from "./Faq";
import Divider from "@/components/Divider.vue";
import DividerTwo from "@/components/DividerTwo.vue";
import FormModal from "@/components/FormModal.vue";
import EventsGallery from "@/components/EventsGallery.vue";

export default {
  components: {
    AppHeader,
    LandingVideo,
    Hero,
    // NextSteps,
    Allstar,
    Perks,
    SeatingPricing,
    // MeetRep,
    Faq,
    Divider,
    DividerTwo,
    FormModal,
    EventsGallery,
  },

  data() {
    return {
      modalActive: false,
    };
  },
  mounted() {
    this.modalShow();
  },

  methods: {
    skipVideo() {
      this.showVideo = false;
    },
    optOutHide() {
      this.OptoutActive = false;
    },
    optOutShow() {
      this.OptoutActive = true;
    },

    upgradeHide() {
      this.upgradeActive = false;
    },
    upgradeShow() {
      this.upgradeActive = true;
    },
    modalShow() {
      this.modalActive = true;
    },
    modalHide() {
      this.modalActive = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
